/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum KraftfahrzeugType {
    Pkw = 'Pkw',
    Lkw = 'Lkw',
    Anhaenger = 'Anhaenger',
    Motorrad = 'Motorrad',
    Moped = 'Moped',
    Bus = 'Bus',
    KennzeichenAufProbe = 'KennzeichenAufProbe',
    Spezialfahrzeug = 'Spezialfahrzeug',
    Traktor = 'Traktor',
    Gelaendewagen = 'Gelaendewagen',
    Transporter = 'Transporter',
    Wohnmobil = 'Wohnmobil',
    SonstigesFahrzeug = 'SonstigesFahrzeug'
  }

    export const KraftfahrzeugTypeTranslocoMap: Record<KraftfahrzeugType, string> = {
    [KraftfahrzeugType.Pkw]: 'kraftfahrzeugType.pkw',
    [KraftfahrzeugType.Lkw]: 'kraftfahrzeugType.lkw',
    [KraftfahrzeugType.Anhaenger]: 'kraftfahrzeugType.anhaenger',
    [KraftfahrzeugType.Motorrad]: 'kraftfahrzeugType.motorrad',
    [KraftfahrzeugType.Moped]: 'kraftfahrzeugType.moped',
    [KraftfahrzeugType.Bus]: 'kraftfahrzeugType.bus',
    [KraftfahrzeugType.KennzeichenAufProbe]: 'kraftfahrzeugType.kennzeichenAufProbe',
    [KraftfahrzeugType.Spezialfahrzeug]: 'kraftfahrzeugType.spezialfahrzeug',
    [KraftfahrzeugType.Traktor]: 'kraftfahrzeugType.traktor',
    [KraftfahrzeugType.Gelaendewagen]: 'kraftfahrzeugType.gelaendewagen',
    [KraftfahrzeugType.Transporter]: 'kraftfahrzeugType.transporter',
    [KraftfahrzeugType.Wohnmobil]: 'kraftfahrzeugType.wohnmobil',
    [KraftfahrzeugType.SonstigesFahrzeug]: 'kraftfahrzeugType.sonstigesFahrzeug',
    };

    export const KraftfahrzeugTypeOptions = [
  { value: KraftfahrzeugType.Pkw, labelKey: 'kraftfahrzeugType.pkw' },
  { value: KraftfahrzeugType.Lkw, labelKey: 'kraftfahrzeugType.lkw' },
  { value: KraftfahrzeugType.Anhaenger, labelKey: 'kraftfahrzeugType.anhaenger' },
  { value: KraftfahrzeugType.Motorrad, labelKey: 'kraftfahrzeugType.motorrad' },
  { value: KraftfahrzeugType.Moped, labelKey: 'kraftfahrzeugType.moped' },
  { value: KraftfahrzeugType.Bus, labelKey: 'kraftfahrzeugType.bus' },
  { value: KraftfahrzeugType.KennzeichenAufProbe, labelKey: 'kraftfahrzeugType.kennzeichenAufProbe' },
  { value: KraftfahrzeugType.Spezialfahrzeug, labelKey: 'kraftfahrzeugType.spezialfahrzeug' },
  { value: KraftfahrzeugType.Traktor, labelKey: 'kraftfahrzeugType.traktor' },
  { value: KraftfahrzeugType.Gelaendewagen, labelKey: 'kraftfahrzeugType.gelaendewagen' },
  { value: KraftfahrzeugType.Transporter, labelKey: 'kraftfahrzeugType.transporter' },
  { value: KraftfahrzeugType.Wohnmobil, labelKey: 'kraftfahrzeugType.wohnmobil' },
  { value: KraftfahrzeugType.SonstigesFahrzeug, labelKey: 'kraftfahrzeugType.sonstigesFahrzeug' },
    ];

